import {Button, Group, Table, Tooltip} from "@mantine/core";
import {IRate} from "../../../api/Rates/Rates.types";
import dayjs from "dayjs";
import NumberUtils from "../../../utils/number.utils";
import {Check, X} from "tabler-icons-react";

interface Props {
    data: IRate[]
    onClickStatus: (contractId: string, approved: true | false) => void,
}

function RatesForApprovalTable({data, onClickStatus}: Props) {

    const rows = data.map((d, i) => {
        const {
            nvoName,
            origin,
            destination,
            shipline,
            dischargePortName,
            fortyHCRate,
            rateStartDate,
            autoExpireRateDate,
            aglContractId
        } = d;

        return (
            <tr key={aglContractId}>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>{aglContractId}</td>
                <td>{nvoName}</td>
                <td>{origin}</td>
                <td>{destination}</td>
                <td>{shipline}</td>
                <td>{dischargePortName}</td>
                <td style={{fontFamily: "IBM Plex Mono, monospace"}}>${fortyHCRate ? NumberUtils.numberWithCommas(parseFloat(fortyHCRate)) : fortyHCRate}</td>
                <td>
                    <Tooltip label={dayjs(rateStartDate).format("MMM DD, YYYY - mm:hh a")}>
                        {dayjs(rateStartDate).format("MMM DD, YYYY")}
                    </Tooltip>
                </td>
                <td>
                    <Tooltip label={dayjs(autoExpireRateDate).format("MMM DD, YYYY - mm:hh a")}>
                        {dayjs(autoExpireRateDate).format("MMM DD, YYYY")}
                    </Tooltip>
                </td>
                <td>
                    <Group>
                        <Button size="xs" color="green" leftIcon={<Check size={16}/>}
                                onClick={() => onClickStatus(aglContractId, true)}>
                            Approve
                        </Button>
                        <Button size="xs" color="red" leftIcon={<X size={16}/>}
                                onClick={() => onClickStatus(aglContractId, false)}>
                            Deny
                        </Button>
                    </Group>
                </td>
            </tr>
        )
    });

    return (
        <Table striped>
            <thead>
            <tr>
                <th>Contract ID</th>
                <th>NVO Name</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Shipline</th>
                <th>Discharge Port</th>
                <th>40 HC Rate</th>
                <th>Rate Start</th>
                <th>Expiration</th>
                <th>Status</th>
            </tr>
            </thead>
            <tbody>{rows}</tbody>
        </Table>
    )
}

export default RatesForApprovalTable;